import React from 'react';


export default function PaddedContainer({ children }) {
  return (
    <div className="px-3 sm:px-6 pt-1 sm:pt-3">
      {children}
    </div>
  );
}